import { Dates } from "src/modules/utils/shared/dates";
import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendForm } from '../../netgen/FrontendForm';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { Utils } from 'src/modules/utils/shared/utils';
import { Objects } from "src/modules/utils/shared/objects";
import { FrontendFieldError } from "../../shared/FrontendFieldError";

@Component({
    selector: 'app-reset-password-link',
    templateUrl: './reset-password-link.component.html',
    styleUrl: './reset-password-link.component.scss',
    standalone: false
})
export class ResetPasswordLinkComponent extends ComponentView {

  message = inject(MessageService);

  neededParams: ObjectOfSimpleDataTypes = { token: "string" };
  token: string;

  form: FrontendForm;
  
  userName = null;
  running = false;
  done = false;
  errorMessage: string;

  async initParams(): Promise<boolean> {
    try {
      this.userName = await RestEndpoint.main().query({ token: this.token }).run("api/app/auth/getResetPasswordLinkUser").getString();
    }
    catch (error) {
      this.errorMessage = Objects.toString(error.error);
    }
    this.form = new FrontendForm([
        new FrontendField("password", "Neues Passwort", FrontendFieldType.password, { 
            mandatory: true, 
            passwordFeedback: false 
        }),
        new FrontendField("passwordRepeat", "Neues Passwort wiederholen", FrontendFieldType.password, { 
            mandatory: true, 
            passwordFeedback: false, 
            validator: (field, item) => field.getValue() != item.getValue("password") ? [new FrontendFieldError(field.id, this.app.t("general.changePassword.newPasswordRepeat_error1"))] : []
        })
    ]);
    return true;
  }

  async send(): Promise<void> {
    let errors = this.form.validate();
    if (!Utils.isNoe(errors)) {
        this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: errors[0].message});
        return;
    }
    if ((await this.app.genericDataHandler(async () => RestEndpoint.main().post().body({ token: this.token, userName: this.userName, password: this.form.getValue("password") }).run("api/app/auth/resetPasswordViaToken").getString(), "Fehler", "dialog")).ok) {
    this.message.add({ severity: "success", summary: "Ihr Passwort wurde erfolgreich zurückgesetzt"});
    Utils.setTimerOnce(3000, async () => {
        await this.app.navigateTo(["/base", "login"]);
    });
    }
  }
}  